import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Запросить консультацию',
  phone: {
    placeholder: 'Введите ваш телефон',
  },
  button: {
    submit: 'Получить консультацию',
  },
} satisfies TMessages
